<ng-container>
  <div class="selection-header" >
    <media-attachment [priority]="true" [forceBackground]="true" class="featured" *ngIf="imageUrl && section?.selection_sit" [alt]="imageAlt" [url]="imageUrl"></media-attachment>
    <div class="grid grid-section intro-container">
      <div class="content reverse">
        <h1 class="h1" [innerHTML]="selection.name"></h1>
        <breacrumbs [hasBackButton]="true" [title]="selection.name"></breacrumbs>
      </div>
    </div>
  </div>
  <div class="page-sections" *ngIf="section?.selection_sit">
      <selection-sit-section #selectionEl  [section]="section" [index]="1"></selection-sit-section>
  </div>
</ng-container>

